export enum Programmes{
    ADMISSIONYEAR = 'Admission Year',
    DEPARTMENT = 'Department',
    UG = 'UG',
    PG = 'PG',
    PHD = 'PhD',
    CAMPUS = 'Campus',
    PROGRAMMEMAPPING = 'Programme Mapping',
    SAVE = 'Save',
    DIPLOMA = 'Diploma',
}